export default __webpack_public_path__ + "static/media/mail.e697d2b1.svg";